import Main from './Main.vue'

export default [{
  path: 'pregao-leiloeiro-patio/:id',
  name: 'pregaoleiloeiropatio',
  component: Main
}
]



// WEBPACK FOOTER //
// ./src/app/website/pregao-leiloeiro-patio/routes.js